import { Fragment } from 'react'

import { ContentPage_content } from 'globalTypes'

interface Props {
  children: React.ReactNode
  content: ContentPage_content
}

const GoToLinkArea = ({ children, content }: Props) => {
  if (content.__typename === 'LinkContent') {
    return (
      <a target="_blank" href={content.url} rel="noreferrer">
        {children}
      </a>
    )
  }

  return <Fragment>{children}</Fragment>
}

export default GoToLinkArea
